export const MAP_DEFAULT_CENTER = {
  latitude: 40.74,
  longitude: -101.19,
};

export const MAP_DEFAULT_ZOOM = 4;
